import { Injectable, inject } from '@angular/core';
import { BaseAppSyncService } from '../base-app-sync.service';
import { DopBuilderService } from '../builder/dop-builder.service';
import { DOPGroup } from '../../model/crm/daily-operating-plan/dop-group';
import { getDOPGroups } from '../../graphql/daily-operating-plans/get-dop-groups';
import { Observable } from 'rxjs';
import { DOPLabel } from '../../model/crm/daily-operating-plan/dop-label';
import { getDOPLabels } from '../../graphql/daily-operating-plans/get-dop-labels';
import {
  CreateDOPEntry,
  DOPEntry,
  UpdateDOPEntry,
} from '../../model/crm/daily-operating-plan/dop-entry';
import { getDOPEntries } from '../../graphql/daily-operating-plans/get-dop-entries';
import { createDOPEntry } from '../../graphql/daily-operating-plans/create-dop-entry';
import { updateDOPEntry } from '../../graphql/daily-operating-plans/update-dop-entry';
import { deleteDOPEntry } from '../../graphql/daily-operating-plans/delete-dop-entry';
import {
  AcknowledgeDOPInput,
  DOPAcknowledgement,
} from '../../model/crm/daily-operating-plan/dop-acknowledegment';
import { acknowledgeDOP } from '../../graphql/daily-operating-plans/acknowledge-dop';
import { hasControllerAcknowledgedDOP } from '../../graphql/daily-operating-plans/has-controller-acknowledged-dop';

@Injectable({
  providedIn: 'root',
})
export class DopApiService extends BaseAppSyncService {
  private _dopBuilder = inject(DopBuilderService);

  getDOPGroups(): Observable<DOPGroup[]> {
    return this.query(
      getDOPGroups,
      {},
      (items: any[]) => items.map((i) => this._dopBuilder.buildDOPGroup(i)),
      'getDOPGroups'
    );
  }

  getDOPLabels(): Observable<DOPLabel[]> {
    return this.query(
      getDOPLabels,
      {},
      (items: any[]) => items.map((i) => this._dopBuilder.buildDOPLabel(i)),
      'getDOPLabels'
    );
  }

  getDOPEntries(dopGroupId: string, shiftDate: string): Observable<DOPEntry[]> {
    return this.query(
      getDOPEntries,
      { dopGroupId, shiftDate },
      (items: any[]) => items.map((i) => this._dopBuilder.buildDOPEntry(i)),
      'getDOPEntries'
    );
  }

  createDOPEntry(input: CreateDOPEntry): Observable<DOPEntry> {
    return this.mutate(
      createDOPEntry,
      { input },
      (i: any) => this._dopBuilder.buildDOPEntry(i),
      'createDOPEntry'
    );
  }

  updateDOPEntry(id: string, input: UpdateDOPEntry): Observable<DOPEntry> {
    return this.mutate(
      updateDOPEntry,
      { id, input },
      (i: any) => this._dopBuilder.buildDOPEntry(i),
      'updateDOPEntry'
    );
  }

  deleteDOPEntry(id: string): Observable<boolean> {
    return this.mutate(
      deleteDOPEntry,
      { id },
      (i: any) => i.value,
      'deleteDOPEntry'
    );
  }

  acknowledgeDOP(input: AcknowledgeDOPInput): Observable<DOPAcknowledgement> {
    return this.mutate(
      acknowledgeDOP,
      { input },
      (i: any) => this._dopBuilder.buildDOPAcknowledgement(i),
      'acknowledgeDOP'
    );
  }

  hasControllerAcknowledgedDOP(
    aorId: string,
    contactId: string,
    shiftDate: string
  ): Observable<boolean> {
    return this.query(
      hasControllerAcknowledgedDOP,
      { aorId, contactId, shiftDate },
      (i: any) => i.value,
      'hasControllerAcknowledgedDOP'
    );
  }
}
